import { Row, Typography } from "antd";
import LinearGauge, { LinearGaugeType } from "./LinearGauge";
import { useMemo } from "react";
import { _decimalPlaces } from "chart.js/helpers";
import React from "react";
import { formatNumber } from "src/utils/formatting";

const { Text } = Typography; 

export interface TemperatureGaugeProps {
    temperature: number | null | undefined;
    label: string; 
    useCelsius: boolean;
}

const TemperatureGauge : React.FC<TemperatureGaugeProps> = ({ temperature, label, useCelsius}) => {

    const tempScaleData = useMemo(() => {
        return useCelsius 
          ? [0, 13, 26, 39, 52, 65, 78, 91, 104, 117, 130]
          : [0, 26, 52, 78, 104, 130, 156, 182, 208, 234, 260];
      }, [useCelsius]);

    const labelSuffx = useCelsius ? " °C" : " °F";

    return(
        <div>
            <div className="custom-gauge-header">
                <Text style={{ fontFamily:'monospace', fontWeight: "bold"}}>{label}: {formatNumber(temperature, { decimalPlaces: 0, suffix: labelSuffx })}</Text>
            </div>
            <div className="custom-gauge-div">
                <LinearGauge 
                currentValue={temperature} 
                scaleData={tempScaleData} 
                colorCodedGaugeExists={false}
                type={LinearGaugeType.Temperature}
                needleAnimationSpeed={0.3}
                />
            </div>
        </div>

    )
}

export default TemperatureGauge;